const PenaltyHeadToHead = ({
  title = "Penalty",
  penalty = "Additional Transfers",
  penaltyPoints = 0,
  icon = "f1i-error",
  isOpponent = false,
  showPenaltyPoints = true,
}) => {
  return (
    <div
      className={`si-h2h-penalty__item ${
        isOpponent ? "si-h2h-penalty__item--opponent" : ""
      }`}
    >
      <div className="si-h2h-penalty__item-content">
        <div className="si-h2h-penalty__item-title">{title}</div>
        <div className="si-h2h-penalty__item-penalty">{penalty}</div>
        {showPenaltyPoints && (
          <div className="si-h2h-penalty__item-penalty-points">
            {penaltyPoints}
          </div>
        )}
      </div>
      <div className="si-h2h-penalty__item-icon">
        <i className={icon}></i>
      </div>
    </div>
  );
};

export default PenaltyHeadToHead;
